import { ePageBaseStatus } from "../../../models/ePageBaseStatus";
import { IConCbnvActionTypes } from "../../action-types/con-cbnv/IConCbnvActionTypes";
import { IConCbnvReducer } from "../../page-state-model/con-cbnv/IConCbnvReduder";
const iniState: IConCbnvReducer = {
    status: ePageBaseStatus.is_not_initialization,
    conCbnvs: []
}
export const conCbnvReducer = (state: IConCbnvReducer = iniState, action: IConCbnvActionTypes): IConCbnvReducer => {
    switch (action.type) {
        case "CON_CBNV_LOAD_START":
            return {
                ...state,
                status: ePageBaseStatus.is_loading
            }
        case "CON_CBNV_LOAD_SUCCESS":
            return {
                ...state,
                status: ePageBaseStatus.is_completed,
                conCbnvs: action.payload
            }
        case "CON_CBNV_LOAD_ERROR":
            return {
                ...state,
                status: ePageBaseStatus.is_completed,
                conCbnvs: []
            }
        case "CON_CBNV_SHOW_EDIT_MODAL":
            return {
                ...state,
                isShowEditModal: true,
                editingData: action.payload
            }
        case "CON_CBNV_CLOSE_EDIT_MODAL":
            return {
                ...state,
                isShowEditModal: false,
            }
        case "CON_CBNV_SAVE_START":
            return {
                ...state,
                status: ePageBaseStatus.is_saving
            }
        case "CON_CBNV_SAVE_SUCESS":
            return {
                ...state,
                status: ePageBaseStatus.is_need_reload,
                isShowEditModal: false
            }
        case "CON_CBNV_SAVE_ERROR":
            return {
                ...state,
                status: ePageBaseStatus.is_completed,
            }
        case "CON_CBNV_DELETE_START":
            return {
                ...state,
                status: ePageBaseStatus.is_deleting
            }
        case "CON_CBNV_DELETE_SUCESS":
            return {
                ...state,
                status: ePageBaseStatus.is_need_reload,
            }
        case "CON_CBNV_DELETE_ERROR":
            return {
                ...state,
                status: ePageBaseStatus.is_completed,
            }
        default:
            return state;
    }
}